export default __webpack_public_path__ + "media/images/icons/times-solid-ea7c95d7120c0efcb4b16602bf9049a5.svg";